export default __webpack_public_path__ + "static/media/ic_arrow_right.becd1da8.svg";